import { FileUploadStatus, FileWithStatus } from '@/types/upload';

export const getFileStatusText = (file: FileWithStatus) => {
  switch (file.status.state) {
    case FileUploadStatus.COMPLETED: {
      return 'Uploaded';
    }
    case FileUploadStatus.FAILED: {
      return 'Failed';
    }
    case FileUploadStatus.UPLOADING: {
      return 'Uploading';
    }
    default: {
      return 'Pending';
    }
  }
};
